const redirectToUrl = (redirectTo, openNewTab = false) => {
  if (redirectTo && openNewTab) {
    window.open(redirectTo, '_blank');
  } else {
    window.location.href = redirectTo;
  }
};

export default redirectToUrl;
